"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Slider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "changed", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      // Persist event so that it can be passed through to debounced event
      var eventValue = parseInt(e.target.value);

      _this.setState({
        value: eventValue
      }, function () {
        _this.changed(eventValue);
      });
    });

    _this.state = {
      value: 0
    }; // Debounce onChange event to prevent over-firing redux events

    _this.changed = (0, _debounce["default"])(_this.props.onUpdate, 250);
    return _this;
  }

  var _proto = Slider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      value: this.props.defaultValue
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.setState({
        value: this.props.defaultValue
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        min = _this$props.min,
        max = _this$props.max,
        unit = _this$props.unit,
        title = _this$props.title,
        valueFormatter = _this$props.valueFormatter;
    var formattedMax = Math.ceil(max);
    var value = this.state.value;
    var barWidth = value / formattedMax * 100;
    var barStyle = {
      width: barWidth + '%'
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "slider"
    }, title, /*#__PURE__*/React.createElement("div", {
      className: "slider__wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slider__bar"
    }), /*#__PURE__*/React.createElement("div", {
      className: "slider__progress-bar",
      style: barStyle
    }), /*#__PURE__*/React.createElement("input", {
      className: "slider__input",
      type: "range",
      onChange: this.handleChange,
      min: min,
      max: formattedMax,
      step: 1,
      value: value
    })), /*#__PURE__*/React.createElement("label", {
      className: "slider__label"
    }, valueFormatter ? valueFormatter(value) : value, unit));
  };

  return Slider;
}(React.Component);

var _default = Slider;
exports["default"] = _default;